import { ModalComponent } from "cruzo/ui-components/modal";
import { appScope } from "site/api";

export type ExerciseImageModalContext = {
  src: string;
  title?: string;
};

let context: ExerciseImageModalContext | null = null;

export function openExerciseImageModal(next: ExerciseImageModalContext): void {
  context = next;
  ModalComponent.attach("exerciseImageModal", appScope.id);
}

export function getExerciseImageModalContext(): ExerciseImageModalContext | null {
  return context;
}

export function clearExerciseImageModalContext(): void {
  context = null;
}
